const TOKEN_KEY = 'etc_as_token'
const STAFF_KEY = 'etc_as_staff'

export const auth = {
  get token() { return localStorage.getItem(TOKEN_KEY) || '' },
  get staff() {
    try { return JSON.parse(localStorage.getItem(STAFF_KEY) || 'null') } catch { return null }
  },
  get role() { return this.staff?.role || '' },
  get isAdmin() { return this.role === 'admin' },
  get isLeader() { return this.role === 'leader' },
  get canManageStaff() { return this.isAdmin || this.isLeader },
  save(token, staff) {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(STAFF_KEY, JSON.stringify(staff))
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(STAFF_KEY)
  },
}

async function request(path, options = {}) {
  const res = await fetch(path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(auth.token ? { Authorization: `Bearer ${auth.token}` } : {}),
      ...options.headers,
    },
  })
  const data = await res.json().catch(() => ({}))
  if (res.status === 401) {
    auth.clear()
    if (!location.hash.includes('/login')) location.hash = '#/login'
    throw new Error(data.error || '登录已失效')
  }
  if (!res.ok) throw new Error(data.error || `请求失败 (${res.status})`)
  return data
}

const qs = (params) => {
  const clean = Object.entries(params || {}).filter(([, v]) => v !== '' && v != null)
  return clean.length ? '?' + new URLSearchParams(clean).toString() : ''
}

export const PROCESS_RESULTS = ['360', '180', '158', '67', '退货退款']
export const PROCESS_RESULT_PENDING = 'pending'

export const api = {
  login: (phone, password) => request('/api/login', { method: 'POST', body: JSON.stringify({ phone, password }) }),
  logout: () => request('/api/logout', { method: 'POST' }),

  listStaff: () => request('/api/staff'),
  createStaff: (body) => request('/api/staff', { method: 'POST', body: JSON.stringify(body) }),
  updateStaff: (id, body) => request(`/api/staff/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  listTeams: () => request('/api/teams'),
  createTeam: (body) => request('/api/teams', { method: 'POST', body: JSON.stringify(body) }),

  listOrders: (params) => request('/api/orders' + qs(params)),
  createOrder: (body) => request('/api/orders', { method: 'POST', body: JSON.stringify(body) }),
  updateOrder: (id, body) => request(`/api/orders/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  deleteOrder: (id) => request(`/api/orders/${id}`, { method: 'DELETE' }),
  revealPhone: (id) => request(`/api/orders/${id}/reveal-phone`, { method: 'POST' }),

  listFollowUps: (id) => request(`/api/orders/${id}/follow-ups`),
  addFollowUp: (id, body) => request(`/api/orders/${id}/follow-ups`, { method: 'POST', body: JSON.stringify(body) }),

  statsDaily: (params) => request('/api/stats/daily' + qs(params)),
  statsStaff: (params) => request('/api/stats/staff' + qs(params)),

  cwtLookup: (keyword) => request('/api/cwt/lookup' + qs({ keyword })),
  cwtStatus: () => request('/api/cwt/status'),
  cwtSaveCredential: (body) => request('/api/cwt/credential', { method: 'POST', body: JSON.stringify(body) }),
}
